import React from 'react'
import { customerLink, orderLink, projectLinkDecorated, projectState } from '../Common/functions';
import { ProjectData } from '../Common/types';
import TruckInfo from '../Project/TruckInfo';
import InlineTaskStatus from './InlineTaskStatus';
import { TT_FLOOR_BEARERS, TT_PURLINS, TT_ROOF, TT_STAIRS, TT_WALL_BEAMS, TT_WINBOARDS_TRIMS } from './List';

interface TableRowWoodPartsProps {
  isChecked: boolean,
  project: ProjectData,
  onCheckboxClick: (project: ProjectData, checked: boolean) => void
  onTruckUpdated: () => void
}

const TableRowWoodParts = (props: TableRowWoodPartsProps) => {

  function toggleChecked(): void {
    props.onCheckboxClick(props.project, !props.isChecked)
  }

  return (
    <tr className={`deadline2-${props.project.deadline_color}`}>
      <td onClick={() => toggleChecked()}>
        <input
          type="checkbox"
          checked={props.isChecked}
          onChange={() => toggleChecked()}
          className="i-checks"
        />
      </td>
      <td>
        {props.project.visible_id}
      </td>
      <td>
        {props.project.walls_thickness ? `${props.project.walls_thickness} mm` : "-"}
      </td>
      <td>
        {orderLink(props.project.order, props.project.order_visible_id)}
      </td>
      <td>
        <>
          {props.project.xls_file1_wood && <i className="fa fa-check text-navy" title="Uploaded"></i>}
          {!props.project.xls_file1_wood && <i className="fa fa-exclamation text-warning pl-1" title="Wood Parts file is required"></i>}
        </>
      </td>

      <td>{projectLinkDecorated(props.project, false, true)}</td>
      <td className={props.project.prod_deadline_after_deadline ? "text-danger" : ""}>
        {props.project.prod_deadline} ({props.project.days_to_prod_deadline})
        {props.project.prod_deadline_after_deadline && (
          <i
            className="fa fa-exclamation-triangle"
            title="Production deadline is after deadline"
          ></i>
        )}
      </td>
      <td>{projectState(props.project)}</td>
      <td>{props.project.tasks_progress}%</td>
      <td>
        {props.project.truck && <TruckInfo truck={props.project.truck} onTruckUpdated={props.onTruckUpdated} ></TruckInfo>}
      </td>
      <td>
        {customerLink(props.project.customer)}
      </td>
      <td>
        {props.project.sales_manager}
      </td>


      <td><InlineTaskStatus taskStatuses={props.project.task_statuses || []} taskTypeId={parseInt(TT_WALL_BEAMS)} /></td>
      <td><InlineTaskStatus taskStatuses={props.project.task_statuses || []} taskTypeId={parseInt(TT_PURLINS)} /></td>
      <td><InlineTaskStatus taskStatuses={props.project.task_statuses || []} taskTypeId={parseInt(TT_ROOF)} /></td>
      <td><InlineTaskStatus taskStatuses={props.project.task_statuses || []} taskTypeId={parseInt(TT_WINBOARDS_TRIMS)} /></td>
      <td><InlineTaskStatus taskStatuses={props.project.task_statuses || []} taskTypeId={parseInt(TT_FLOOR_BEARERS)} /></td>
      <td><InlineTaskStatus taskStatuses={props.project.task_statuses || []} taskTypeId={parseInt(TT_STAIRS)} /></td>
      <td>?</td>

      <td>
        {props.project.order_date}
      </td>

    </tr >

  )
}

export default TableRowWoodParts
